import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { NavButton } from 'components/Button'

const ProductOrderCompleteTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/product.svg'} alt={'アプリでの並び順が反映されました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          アプリでの並び順が
          <br />
          反映されました
        </h2>
      </FlexColumn>
      <Spacer size={48} />
      <NavButton label={'sacriで出品する商品の管理に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/product'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ProductOrderCompleteTemplate
